let token: string | null = null;

export const getToken = () => token;
export const setToken = (t: string) => {
  token = t;
};
export const clearToken = () => {
  token = null;
};
